import { useMemo, type ComponentProps } from "react";
import { getNavigationConfig } from "./nav-config";
import { cn } from "@/utilities/app-utils";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader
} from "@/components/ui/sidebar";
import { InnerShadowTopIcon } from "@/utilities/icon-utils";
import { layout, sizes, spacing, typography } from "@/utilities";
import { useUserContext } from "@/context/user-context";
import { NavMain } from "./nav-main";
import { NavUser } from "./nav-user";
import { NavSecondary } from "./nav-secondary";
import { config } from "@/config/environment";

export function AppSidebar({ ...props }: ComponentProps<typeof Sidebar>) {
  const { user } = useUserContext();

  // Get navigation configuration based on user type
  const navigationConfig = useMemo(() => {
    return user && user.userType ? getNavigationConfig(user.userType) : null;
  }, [user]);

  if (!user || !user.userType || !navigationConfig) {
    return null;
  }

  return (
    <Sidebar {...props}>
      <SidebarHeader>
        <div className={cn(layout.flexCenterGap2, spacing.px1, spacing.py2)}>
          <InnerShadowTopIcon className={cn(sizes.size7)} />
          <span className={cn(typography.textMdSemibold)}>{config.app.name}</span>
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navigationConfig.main} />
        <NavSecondary items={navigationConfig.secondary} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser variant="sidebar" />
      </SidebarFooter>
    </Sidebar>
  );
}
